import { useEffect, useState } from "react"

import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    FormHelperText,
    InputLabel,
    TextField,
    Box,
    Chip
} from '@mui/material';

import { useReportContext } from "../../../../context/ReportContext";
import DatePickerComponent from "../../../common/DatePickerComponent"

export function BasicFilter() {

    const {
        t,
        formik,
        disableSearchInput,
        availableLocations
    } = useReportContext()

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

    return (
        <Grid container columnSpacing={1} rowSpacing={0}>
            <Grid item sm={6} xs={6} md={6}>
                <DatePickerComponent
                    sx={{
                        width: '100%'
                    }}
                    config={{
                        name: "dateFrom",
                        label: t("documentDateFrom")
                    }}
                    formik={{
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue
                    }}
                    disabled={disableSearchInput}
                />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
                <DatePickerComponent
                    sx={{
                        width: '100%'
                    }}
                    config={{
                        name: "dateTo",
                        label: t("documentDateTo")
                    }}
                    formik={{
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue
                    }}
                    disabled={disableSearchInput}
                />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
                <DatePickerComponent
                    sx={{
                        width: '100%'
                    }}
                    config={{
                        name: "createDateFrom",
                        label: t("createDateFrom")
                    }}
                    formik={{
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue
                    }}
                    disabled={disableSearchInput}
                />
            </Grid>
            <Grid item sm={6} xs={6} md={6}>
                <DatePickerComponent
                    sx={{
                        width: '100%'
                    }}
                    config={{
                        name: "createDateTo",
                        label: t("createDateTo")
                    }}
                    formik={{
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue
                    }}
                    disabled={disableSearchInput}
                />
            </Grid>
            <Grid item sm={12} xs={12} md={12}>
                <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={Boolean(errors.locationIds)}
                    disabled={disableSearchInput}
                >
                    <InputLabel id="locationIds">{t("location")}</InputLabel>
                    <Select
                        labelId="locationIds"
                        label="Target"
                        name={"locationIds"}
                        onChange={handleChange}
                        value={values.locationIds}
                        sx={{
                            textAlign: 'left'
                        }}
                        // renderValue={(selected) => selected.join(', ')}
                        renderValue={(selected) => {

                            let locationList = []
                            let locationInfo = []
                            let locationName = []

                            locationList = Object.keys(availableLocations).map(item => {
                                return(
                                    availableLocations[item]
                                )
                            })

                            return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {
                                        selected.map((value, index) => {

                                            locationInfo = locationList.filter(i => i.id === value)

                                            locationName = locationInfo.length ? locationInfo[0].location_name : '-'

                                            return (
                                                <Chip key={index} label={locationName} />
                                            )
                                        })
                                    }
                                </Box>
                            )

                        }}
                        multiple
                    >
                        {
                            Object.keys(availableLocations).map((i, index) => {

                                let item = availableLocations[i]

                                return (
                                    <MenuItem key={index} value={item.id}>
                                        {t(item.location_name)}
                                    </MenuItem>
                                )

                            })
                        }

                    </Select>
                    <FormHelperText>
                        {errors?.locationIds}
                    </FormHelperText>
                </FormControl>
            </Grid>
        </Grid>
    )
}

export function AdvancedFilter() {

    const {
        t,
        formik,
        disableSearchInput,
        // availableLocations
    } = useReportContext()

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

    return (
        <Grid container columnSpacing={1} rowSpacing={0}>
            <Grid item sm={12} xs={12} md={6}>
                <TextField
                    disabled={disableSearchInput}
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"documentNo"}
                    label={t("documentNo")}
                    type="text"
                    variant="outlined"
                    value={values.documentNo}
                    onChange={handleChange}
                    error={touched.documentNo && Boolean(errors.documentNo)}
                    helperText={touched.documentNo && errors.companyName}
                />
            </Grid>

            <Grid item sm={12} xs={12} md={6}>
                <TextField
                    disabled={disableSearchInput}
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"profileName"}
                    label={t("profileName")}
                    type="text"
                    variant="outlined"
                    value={values.profileName}
                    onChange={handleChange}
                    error={Boolean(errors.profileName)}
                    helperText={errors.profileName}
                />
            </Grid>

            <Grid item sm={12} xs={12} md={6}>
                <TextField
                    disabled={disableSearchInput}
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"deliveryProfileName"}
                    label={t("deliveryProfileName")}
                    type="text"
                    variant="outlined"
                    value={values.deliveryProfileName}
                    onChange={handleChange}
                    error={Boolean(errors.deliveryProfileName)}
                    helperText={errors.deliveryProfileName}
                />
            </Grid>

            <Grid item sm={12} xs={12} md={6}>
                <TextField
                    disabled={disableSearchInput}
                    margin="dense"
                    size="small"
                    fullWidth
                    name={"billingProfileName"}
                    label={t("billingProfileName")}
                    type="text"
                    variant="outlined"
                    value={values.billingProfileName}
                    onChange={handleChange}
                    error={Boolean(errors.billingProfileName)}
                    helperText={errors.billingProfileName}
                />
            </Grid>


        </Grid>
    )
}